import { DurationType } from "@api/models/enums/DurationType";

export class Duration {
  type: DurationType = DurationType.MONTH;
  amount!: number;
}
